/* Tee Dimension — Wear Your World
   Shopify theme script. Ports the full animated experience (ember field,
   cursor glow, scroll reveal, wormhole dive, theme toggle, cart drawer,
   bundle meter) onto the real Shopify cart via /cart.js. */
(function () {
  'use strict';

  function fmt(n) { return '$' + Number(n).toFixed(2); }

  /* ---------- Bundle discount tiers (buy more, save more) ---------- */
  function bundleTier(count) {
    if (count >= 4) return { pct: 0.20, label: '20% off — max stack' };
    if (count >= 3) return { pct: 0.15, label: '15% off' };
    if (count >= 2) return { pct: 0.10, label: '10% off' };
    return { pct: 0, label: 'Add 1 more to unlock 10% off' };
  }

  /* ---------- Theme toggle ---------- */
  var theme = 'dark';
  var activeSize = null, activeColor = null, activeRealm = null;

  function syncVariant() {
    var vSel = document.querySelector('[data-variant-select]');
    if (!vSel) return;
    var opts = vSel.querySelectorAll('option');
    var best = null;
    for (var i = 0; i < opts.length; i++) {
      var ov = [];
      try { ov = JSON.parse(opts[i].getAttribute('data-options') || '[]'); } catch (e) { ov = []; }
      if ((!activeSize || ov.indexOf(activeSize) >= 0) && (!activeColor || ov.indexOf(activeColor) >= 0) && (!activeRealm || ov.indexOf(activeRealm) >= 0)) { best = opts[i]; break; }
    }
    if (!best) {
      for (var j = 0; j < opts.length; j++) {
        var ov2 = [];
        try { ov2 = JSON.parse(opts[j].getAttribute('data-options') || '[]'); } catch (e) { ov2 = []; }
        if (!activeSize || ov2.indexOf(activeSize) >= 0) { best = opts[j]; break; }
      }
    }
    if (!best) return;
    vSel.value = best.value;
    vSel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setTheme(t) {
    theme = t;
    document.documentElement.setAttribute('data-theme', t);
    var btn = document.getElementById('theme-toggle');
    if (!btn) return;
    btn.setAttribute('aria-label', 'Switch to ' + (t === 'dark' ? 'light' : 'dark') + ' mode');
    btn.innerHTML = t === 'dark'
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>';
  }

  /* ---------- Toast ---------- */
  function toast(msg, ok) {
    var wrap = document.getElementById('toast-wrap');
    if (!wrap) return;
    var el = document.createElement('div');
    el.className = 'toast';
    el.innerHTML = '<span class="t-icon">' + (ok ? '✓' : '•') + '</span><span>' + msg + '</span>';
    wrap.appendChild(el);
    setTimeout(function () { el.style.opacity = '0'; el.style.transition = 'opacity 300ms'; }, 2200);
    setTimeout(function () { el.remove(); }, 2600);
  }

  /* ---------- Ember burst (add-to-bag) ---------- */
  function emberBurst(x, y, color) {
    var c = document.createElement('div');
    c.className = 'burst';
    c.style.left = x + 'px';
    c.style.top = y + 'px';
    var n = 14;
    for (var i = 0; i < n; i++) {
      var a = Math.random() * Math.PI * 2;
      var dist = 22 + Math.random() * 52;
      var s = document.createElement('i');
      s.style.setProperty('--dx', Math.cos(a) * dist);
      s.style.setProperty('--dy', Math.sin(a) * dist);
      s.style.setProperty('--b', color);
      c.appendChild(s);
    }
    document.body.appendChild(c);
    setTimeout(function () { if (c.parentNode) c.parentNode.removeChild(c); }, 750);
  }

  /* ---------- Ambient ember field ---------- */
  function initEmbers() {
    var canvas = document.getElementById('ember-field');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var coarse = window.matchMedia('(hover: none)').matches;
    var animating = true;
    var W = 0, H = 0, DPR = Math.min(2, window.devicePixelRatio || 1);
    var parts = [], raf = null;

    function size() {
      W = window.innerWidth; H = window.innerHeight;
      canvas.width = Math.floor(W * DPR); canvas.height = Math.floor(H * DPR);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      seed();
    }
    function seed() {
      var n = Math.max(24, Math.min(64, Math.floor(W / 24)));
      parts = [];
      for (var i = 0; i < n; i++) {
        parts.push({
          x: Math.random() * W, y: Math.random() * H,
          r: 0.6 + Math.random() * 2.1,
          vy: 0.10 + Math.random() * 0.45,
          sway: Math.random() * Math.PI * 2,
          swayV: 0.004 + Math.random() * 0.012,
          tw: Math.random() * Math.PI * 2,
          twV: 0.01 + Math.random() * 0.03,
          gold: Math.random() < 0.42
        });
      }
    }
    function draw() {
      if (coarse) { animating = false; }
      if (!animating) return;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.y -= p.vy; p.sway += p.swayV; p.tw += p.twV;
        if (p.y < -12) { p.y = H + 12; p.x = Math.random() * W; }
        var x = p.x + Math.sin(p.sway) * 16;
        var a = 0.14 + 0.40 * (0.5 + 0.5 * Math.sin(p.tw));
        var c = p.gold ? '214,169,45' : '255,106,36';
        ctx.beginPath();
        ctx.arc(x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(' + c + ',' + a.toFixed(3) + ')';
        ctx.fill();
      }
      raf = requestAnimationFrame(draw);
    }

    window.addEventListener('resize', size);
    size();
    if (coarse || reduced) {
      animating = false;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        var a = 0.14 + 0.40 * (0.5 + 0.5 * Math.sin(p.tw));
        var c2 = p.gold ? '214,169,45' : '255,106,36';
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(' + c2 + ',' + a.toFixed(3) + ')';
        ctx.fill();
      }
      animating = true;
    } else {
      raf = requestAnimationFrame(draw);
    }
  }

  /* ---------- Cursor glow ---------- */
  function initCursorGlow() {
    var el = document.querySelector('.cursor-glow');
    if (!el) return;
    if (window.matchMedia('(hover: none)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var half = el.offsetWidth / 2 || 280;
    var tx = -600, ty = -600, cx = -600, cy = -600;
    var on = false;
    document.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      if (!on) { on = true; el.classList.add('on'); cx = tx; cy = ty; }
    });
    document.documentElement.addEventListener('mouseleave', function () {
      on = false; el.classList.remove('on');
    });
    (function loop() {
      cx += (tx - cx) * 0.16; cy += (ty - cy) * 0.16;
      el.style.transform = 'translate3d(' + (cx - half) + 'px,' + (cy - half) + 'px,0)';
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- Scroll reveal (rise through a portal) ---------- */
  var revealIO = null;
  function setupReveals() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sel = '.section-head, .portal, .review-card, .hero-meta, .cta-row, .realm-banner, .bundle-widget, .float-card, .capture-form, .accordion, .step, .benefit, .plan, .value-cell, .j';
    var els = document.querySelectorAll(sel);
    if (revealIO) revealIO.disconnect();
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('revealed'); revealIO.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      if (el.classList.contains('revealed')) return;
      el.classList.add('reveal');
      var parent = el.parentElement;
      var delay = 0;
      if (parent) {
        var sibs = Array.prototype.slice.call(parent.children);
        var idx = sibs.indexOf(el);
        if (idx > 0) delay = Math.min(idx * 60, 300);
      }
      el.style.setProperty('--rd', delay + 'ms');
      revealIO.observe(el);
    });
  }

  /* ---------- Wormhole (portal dive page transition) ---------- */
  function runSpeedometer(duration) {
    var val = document.getElementById('hud-val');
    if (!val) return;
    var MAX = 2000;
    var start = performance.now();
    function tick(now) {
      var t = Math.min(1, (now - start) / duration);
      var eased = t * t * (3 - 2 * t);
      var eased2 = eased * eased * (3 - 2 * eased);
      var n = Math.round(MAX * eased2);
      val.textContent = ('0000' + n).slice(-4);
      if (t < 1) requestAnimationFrame(tick);
      else val.textContent = '2000';
    }
    requestAnimationFrame(tick);
  }

  function wormhole(ringColor, href, label) {
    var wh = document.getElementById('wormhole');
    if (!wh) { window.location = href; return; }
    wh.style.setProperty('--ring', ringColor || 'var(--ember)');
    var lbl = document.getElementById('hud-label');
    if (lbl) lbl.textContent = label || 'Entering Dimension';

    document.body.classList.add('diving');
    wh.classList.add('running');
    runSpeedometer(1350);

    setTimeout(function () {
      wh.classList.remove('running');
      document.body.classList.remove('diving');
      window.location = href;
    }, 1350);
  }

  /* ---------- Cart (Shopify AJAX) ---------- */
  var cartCache = null;

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function addToCart(variantId, qty, opts) {
    opts = opts || {};
    var body = JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body
    }).then(function (r) { return r.json(); })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        cartCache = cart;
        updateCartUI(cart);
        toast('Added to your bag', true);
        openDrawer();
        var burstColor = opts.color || '#FF6A24';
        var bx = opts.x, by = opts.y;
        if (bx == null || by == null) {
          var cb = document.getElementById('cart-btn');
          if (cb) { var r = cb.getBoundingClientRect(); bx = r.left + r.width / 2; by = r.top + r.height / 2; }
        }
        if (bx != null && by != null) emberBurst(bx, by, burstColor);
      })
      .catch(function () { toast('Could not add to bag', false); });
  }

  function changeQty(lineIdx, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIdx, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function (cart) { cartCache = cart; updateCartUI(cart); });
  }

  function cartCount(cart) { return cart ? cart.item_count : 0; }

  function updateCartUI(cart) {
    var count = cartCount(cart);
    var badge = document.getElementById('cart-count');
    if (badge) {
      badge.hidden = count === 0;
      badge.textContent = count;
    }
    renderCart(cart);
    updateBundleWidgets(count);
    updateFreeShipping(cart);
  }

  function updateFreeShipping(cart) {
    var el = document.querySelector('[data-free-ship]');
    if (!el) return;
    var subtotal = (cart && cart.items_subtotal_price) || 0;
    var THRESHOLD = 10000; // $100
    var progress = Math.min(subtotal / THRESHOLD * 100, 100);
    var bar = el.querySelector('[data-fs-progress]');
    var status = el.querySelector('[data-fs-status]');
    if (bar) bar.style.width = progress + '%';
    if (status) {
      if (subtotal >= THRESHOLD) status.textContent = 'Free shipping unlocked';
      else status.textContent = "You're " + fmt((THRESHOLD - subtotal) / 100) + ' away';
    }
  }

  function renderCart(cart) {
    var body = document.getElementById('cart-body');
    var foot = document.getElementById('cart-foot');
    if (!body || !foot) return;
    if (!cart || cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><div class="icon">⬚</div><p>Your bag is empty.</p><p style="font-size:var(--text-sm)">Step through a portal and find the shirt that fits your world.</p><a class="btn btn-primary" href="/collections/all" style="margin-top:var(--space-5)" data-close-cart>Shop the Dimensions</a></div>';
      foot.innerHTML = '';
      return;
    }

    var items = cart.items.map(function (x, idx) {
      var img = (x.featured_image && x.featured_image.url) ? x.featured_image.url : (x.image || '');
      var title = x.product_title || x.title;
      var variantTitle = (x.variant_title && x.variant_title !== 'Default Title') ? x.variant_title : '';
      var linePrice = x.final_line_price || x.line_price;
      var lineIdx = idx + 1; // /cart/change.js uses 1-based line indexes
      return '' +
      '<div class="cart-item">' +
        '<img src="' + img + '" alt="' + title + '">' +
        '<div>' +
          '<div class="ci-name">' + title + '</div>' +
          '<div class="ci-meta">' + variantTitle + '</div>' +
          '<div class="ci-qty"><button data-qty="-1" data-line="' + lineIdx + '" aria-label="Decrease">−</button><span>' + x.quantity + '</span><button data-qty="1" data-line="' + lineIdx + '" aria-label="Increase">+</button></div>' +
          '<button class="ci-remove" data-remove="' + lineIdx + '">Remove</button>' +
        '</div>' +
        '<div class="ci-price">' + fmt(linePrice / 100) + '</div>' +
      '</div>';
    }).join('');

    var subtotal = cart.items_subtotal_price || 0;
    var count = cart.item_count;
    var tier = bundleTier(count);
    var discount = subtotal * tier.pct;
    var total = subtotal - discount;
    var freeShip = total >= 10000; // $100
    var shipping = freeShip ? 0 : 695; // $6.95
    var grand = total + shipping;

    var stackCopy = tier.pct > 0
      ? 'You unlocked <b>' + Math.round(tier.pct * 100) + '% off</b> your whole bag.'
      : 'Add ' + (2 - count) + ' more to unlock <b>10% off</b>.';

    body.innerHTML = items;
    foot.innerHTML =
      '<div class="stack-meter">' +
        '<div class="stack-track">' +
          '<i data-progress style="width:' + Math.min(count / 4 * 100, 100) + '%"></i>' +
          '<span class="stack-tick" style="left:50%"></span>' +
          '<span class="stack-tick" style="left:75%"></span>' +
          '<span class="stack-tick" style="left:100%"></span>' +
        '</div>' +
        '<div class="stack-labels"><span>10% off</span><span>15% off</span><span>20% off</span></div>' +
        '<p class="stack-copy">' + stackCopy + '</p>' +
      '</div>' +
      '<div class="cart-line"><span>Subtotal</span><span>' + fmt(subtotal / 100) + '</span></div>' +
      (discount > 0 ? '<div class="cart-line discount"><span>Bundle savings (' + Math.round(tier.pct * 100) + '%)</span><span>−' + fmt(discount / 100) + '</span></div>' : '') +
      '<div class="cart-line muted"><span>Shipping</span><span>' + (freeShip ? 'Free' : fmt(shipping / 100)) + '</span></div>' +
      '<div class="cart-line total"><span>Total</span><b>' + fmt(grand / 100) + '</b></div>' +
      '<a class="btn btn-primary block" style="margin-top:var(--space-4)" href="/checkout">Checkout securely</a>' +
      '<p style="text-align:center;color:var(--text-faint);font-size:var(--text-xs);margin-top:var(--space-3)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:11px;height:11px;display:inline;vertical-align:-1px"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg> SSL-encrypted checkout · 30-day returns · Free shipping $100+</p>';
  }

  function updateBundleWidgets(count) {
    var tier = bundleTier(count);
    document.querySelectorAll('[data-bundle-widget], [data-shop-stack]').forEach(function (w) {
      var bar = w.querySelector('[data-progress]');
      var copy = w.querySelector('[data-bundle-copy]');
      if (bar) bar.style.width = Math.min(count / 4 * 100, 100) + '%';
      if (copy) {
        if (tier.pct > 0) copy.innerHTML = 'You unlocked <b>' + Math.round(tier.pct * 100) + '% off</b> your whole bag.';
        else copy.innerHTML = 'Add ' + (2 - count) + ' more to unlock <b>10% off</b>.';
      }
      var rows = w.querySelectorAll('.tier-row');
      rows.forEach(function (r, i) { r.classList.toggle('active', i + 2 <= count); });
    });
  }

  /* ---------- Shop filters (size / color / stock) ---------- */
  var shopState = { size: null, color: null, inStockOnly: false };

  function swatchColor(name) {
    var map = {
      'Black': '#1A1A18', 'Charcoal': '#4A4A48', 'Graphite': '#3A3A38', 'Navy': '#2B3A55',
      'Heather Grey': '#B9B9B5', 'Slate Grey': '#7A8288', 'White': '#ECEAE4',
      'Forest Green': '#2A4A3C', 'Forest': '#2A4A3C', 'Espresso Brown': '#4A3B32',
      'Crimson': '#8E2A2A', 'Cream': '#E6DECB'
    };
    return map[name] || '#1A1A18';
  }

  function collectUnique(list) {
    var seen = {}, out = [];
    list.forEach(function (v) { if (v && !seen[v]) { seen[v] = true; out.push(v); } });
    return out;
  }

  function titleCase(s) {
    return String(s).toLowerCase().replace(/(^|[\s-])([a-z])/g, function (_, sep, ch) { return sep + ch.toUpperCase(); });
  }

  function buildFilterPills() {
    var cards = document.querySelectorAll('.product-grid .card');
    var sizes = [], colorMap = {};
    cards.forEach(function (c) {
      sizes = sizes.concat((c.getAttribute('data-sizes') || '').split('|').filter(Boolean));
      (c.getAttribute('data-colors') || '').split('|').filter(Boolean).forEach(function (raw) {
        var key = raw.toLowerCase().trim();
        if (key && !colorMap[key]) colorMap[key] = titleCase(raw);
      });
    });
    sizes = collectUnique(sizes);
    var colors = Object.keys(colorMap).map(function (k) { return colorMap[k]; });
    var sizeRow = document.querySelector('[data-size-pills]');
    var colorRow = document.querySelector('[data-color-pills]');
    if (sizeRow) sizeRow.innerHTML = sizes.map(function (s) {
      var on = shopState.size === s;
      return '<button class="btn ' + (on ? 'btn-primary' : 'btn-ghost') + '" data-shop-size="' + s + '" style="min-height:36px;min-width:44px" aria-pressed="' + on + '">' + s + '</button>';
    }).join('');
    if (colorRow) colorRow.innerHTML = colors.map(function (c) {
      var on = shopState.color === c;
      return '<button class="btn ' + (on ? 'btn-primary' : 'btn-ghost') + '" data-shop-color="' + c + '" style="min-height:36px" aria-pressed="' + on + '"><span class="dot" style="background:' + swatchColor(c) + '"></span>' + c + '</button>';
    }).join('');
  }

  function applyFilters() {
    var cards = document.querySelectorAll('.product-grid .card');
    var visible = 0;
    cards.forEach(function (c) {
      var sizes = (c.getAttribute('data-sizes') || '').split('|').filter(Boolean);
      var colors = (c.getAttribute('data-colors') || '').split('|').filter(Boolean).map(function (x) { return x.toLowerCase().trim(); });
      var stock = c.getAttribute('data-stock') || 'in';
      var ok = true;
      if (shopState.size && sizes.indexOf(shopState.size) < 0) ok = false;
      if (shopState.color && colors.indexOf(shopState.color.toLowerCase()) < 0) ok = false;
      if (shopState.inStockOnly && stock === 'out') ok = false;
      c.style.display = ok ? '' : 'none';
      if (ok) visible++;
    });
    var grid = document.querySelector('.product-grid');
    var empty = document.querySelector('.shop-empty');
    if (visible === 0) {
      if (!empty) {
        empty = document.createElement('div');
        empty.className = 'shop-empty';
        empty.innerHTML = '<p>Nothing matches those filters.</p><button class="btn btn-ghost" data-clear-filters type="button">Clear filters</button>';
        if (grid && grid.parentElement) grid.parentElement.appendChild(empty);
      }
      empty.style.display = '';
    } else if (empty) {
      empty.style.display = 'none';
    }
    updateFilterCount();
  }

  function updateFilterCount() {
    var n = 0;
    if (shopState.size) n++;
    if (shopState.color) n++;
    if (shopState.inStockOnly) n++;
    var badge = document.querySelector('[data-filter-count]');
    if (badge) {
      badge.hidden = n === 0;
      badge.textContent = n;
    }
  }

  function clearFilters() {
    shopState = { size: null, color: null, inStockOnly: false };
    var stockBtn = document.querySelector('[data-shop-stock]');
    if (stockBtn) { stockBtn.classList.remove('btn-primary'); stockBtn.classList.add('btn-ghost'); stockBtn.setAttribute('aria-pressed', 'false'); }
    buildFilterPills();
    applyFilters();
  }

  /* ---------- Drawer / modal ---------- */
  function openDrawer() {
    var d = document.getElementById('cart-drawer'); if (d) d.classList.add('show');
    var o = document.getElementById('cart-overlay'); if (o) o.classList.add('show');
  }
  function closeDrawer() {
    var d = document.getElementById('cart-drawer'); if (d) d.classList.remove('show');
    var o = document.getElementById('cart-overlay'); if (o) o.classList.remove('show');
  }
  function closeAllModals() {
    document.querySelectorAll('.modal').forEach(function (m) { m.classList.remove('show'); });
  }

  /* ---------- Video autoplay / lazy ---------- */
  function forceBackgroundAutoplay() {
    document.querySelectorAll('.hero-video, .memb-video, .realm-bg').forEach(function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      var tryPlay = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      tryPlay();
      v.addEventListener('loadeddata', tryPlay, { once: true });
      v.addEventListener('canplay', tryPlay, { once: true });
    });
  }

  var lazyVidIO = null;
  function setupLazyVideos() {
    if (lazyVidIO) lazyVidIO.disconnect();
    lazyVidIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { v.play().catch(function () {}); lazyVidIO.unobserve(v); }
        else { v.pause(); }
      });
    }, { rootMargin: '220px' });
    document.querySelectorAll('.arch-img').forEach(function (v) { lazyVidIO.observe(v); });
  }

  /* ---------- Subscription realm badge sync ---------- */
  function syncRealmLine(pill) {
    var line = document.querySelector('[data-realm-line]');
    if (!line || !pill) return;
    var color = pill.getAttribute('data-realm-color');
    var name = pill.getAttribute('data-realm-name');
    if (color) line.style.setProperty('--badge', color);
    if (name) {
      var lbl = line.querySelector('[data-realm-label]');
      if (lbl) lbl.textContent = name;
    }
  }

  /* ---------- PDP image gallery (front / back) ---------- */
  function swapMain(url, fade) {
    var main = document.getElementById('pdp-main-img');
    if (!main || !url) return;
    if (main.getAttribute('src') === url) return;
    if (fade) {
      main.style.opacity = '0';
      setTimeout(function () {
        main.setAttribute('src', url);
        main.onload = function () { main.style.opacity = '1'; };
      }, 180);
    } else {
      main.setAttribute('src', url);
    }
  }

  function updateThumbs(backUrl, hasBack, frontUrl) {
    var strip = document.querySelector('.pdp-thumbs');
    if (!strip) return;
    var frontBtn = strip.querySelector('[data-view="front"]');
    var backBtn = strip.querySelector('[data-view="back"]');
    var backImg = backBtn ? backBtn.querySelector('img') : null;
    if (frontUrl && frontBtn) {
      var ft = frontUrl.replace('width=1200', 'width=160');
      var fi = frontBtn.querySelector('img');
      if (fi && fi.getAttribute('src') !== ft) fi.setAttribute('src', ft);
    }
    if (hasBack && backUrl && backBtn) {
      backBtn.style.display = '';
      var thumb = backUrl.replace('width=1200', 'width=160');
      if (backImg && backImg.getAttribute('src') !== thumb) backImg.setAttribute('src', thumb);
    } else if (backBtn) {
      backBtn.style.display = 'none';
      // if currently on back, revert to front
      if (backBtn.classList.contains('active')) {
        var main = document.getElementById('pdp-main-img');
        if (main) swapMain(main.getAttribute('data-front'), false);
        var f = strip.querySelector('[data-view="front"]');
        if (f) f.classList.add('active');
        backBtn.classList.remove('active');
      }
    }
  }

  /* ---------- Card try-on chip: keyboard support ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var chip = e.target.closest('.card-tryon, [data-tryon-url]');
    if (!chip || chip.tagName === 'A' || chip.tagName === 'BUTTON') return;
    e.preventDefault();
    var href = chip.getAttribute('data-tryon-url');
    if (href) window.location.href = href;
  });

  /* ---------- Event delegation ---------- */
  document.addEventListener('click', function (e) {
    var tryonChip = e.target.closest('.card-tryon, [data-tryon-url]');
    if (tryonChip) {
      e.preventDefault();
      e.stopPropagation();
      var tryonHref = tryonChip.getAttribute('data-tryon-url');
      if (tryonHref) window.location.href = tryonHref;
      return;
    }

    var el = e.target.closest('[data-portal]');
    if (el) {
      e.preventDefault();
      var color = el.getAttribute('data-color') || 'var(--ember)';
      var href = el.getAttribute('href');
      var label = 'Entering ' + (el.getAttribute('data-label') || 'Dimension');
      wormhole(color, href, label);
      return;
    }

    var retBtn = e.target.closest('[data-return]');
    if (retBtn) {
      e.preventDefault();
      var rc = retBtn.getAttribute('data-color') || 'var(--ember)';
      wormhole(rc, retBtn.getAttribute('href') || '/', 'Returning to the Universe');
      return;
    }

    var addBtn = e.target.closest('[data-add]');
    if (addBtn) {
      e.preventDefault();
      var vid = addBtn.getAttribute('data-add');
      var qty = parseInt(addBtn.getAttribute('data-qty') || '1', 10);
      var color = addBtn.getAttribute('data-color') || '#FF6A24';
      addToCart(vid, qty, { color: color, x: e.clientX, y: e.clientY });
      if (addBtn.hasAttribute('data-close-modal')) closeAllModals();
      return;
    }

    var qtyBtn = e.target.closest('[data-qty]');
    if (qtyBtn) {
      var delta = parseInt(qtyBtn.getAttribute('data-qty'), 10);
      var line = qtyBtn.getAttribute('data-line');
      if (line) {
        var lineIdx = parseInt(line, 10);
        var item = cartCache && cartCache.items && cartCache.items[lineIdx - 1];
        if (item) changeQty(lineIdx, item.quantity + delta);
      } else {
        var qv = document.getElementById('qty-val');
        if (qv) { var cur = parseInt(qv.textContent, 10) || 1; qv.textContent = Math.max(1, cur + delta); }
      }
      return;
    }

    var removeBtn = e.target.closest('[data-remove]');
    if (removeBtn) { changeQty(parseInt(removeBtn.getAttribute('data-remove'), 10), 0); return; }

    var sizeBtn = e.target.closest('[data-size]');
    if (sizeBtn) {
      document.querySelectorAll('.pdp-info .size-chip').forEach(function (s) { s.classList.remove('active'); });
      sizeBtn.classList.add('active');
      activeSize = sizeBtn.getAttribute('data-size');
      syncVariant();
      return;
    }

    var swatch = e.target.closest('[data-color]');
    if (swatch) {
      document.querySelectorAll('.pdp-color-switch .swatch').forEach(function (s) { s.classList.remove('active'); });
      swatch.classList.add('active');
      activeColor = swatch.getAttribute('data-color');
      var lbl = document.getElementById('color-label');
      if (lbl) lbl.textContent = activeColor;
      // store front + back image urls on the main image element
      var main = document.getElementById('pdp-main-img');
      var front = swatch.getAttribute('data-img');
      var back = swatch.getAttribute('data-back');
      if (main && front) {
        main.setAttribute('data-front', front);
        main.setAttribute('data-back', back || '');
        swapMain(front, false);
        updateThumbs(back || '', !!back, front);
      }
      syncVariant();
      return;
    }

    var thumb = e.target.closest('[data-view]');
    if (thumb && thumb.classList.contains('pdp-thumb')) {
      var strip = thumb.closest('.pdp-thumbs');
      strip.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      var main = document.getElementById('pdp-main-img');
      if (main) {
        var v = thumb.getAttribute('data-view');
        var url = v === 'back' ? main.getAttribute('data-back') : main.getAttribute('data-front');
        if (url) swapMain(url, true);
      }
      return;
    }

    var accordion = e.target.closest('[data-accordion] .accordion-head');
    if (accordion) { accordion.parentElement.classList.toggle('open'); return; }

    var sc = e.target.closest('[data-scroll]');
    if (sc) { var tgt = document.querySelector(sc.getAttribute('data-scroll')); if (tgt) tgt.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }

    var ft = e.target.closest('[data-filter-toggle]');
    if (ft) {
      var dd = document.querySelector('[data-filter-dropdown]');
      if (dd) {
        dd.classList.toggle('open');
        ft.setAttribute('aria-expanded', dd.classList.contains('open'));
      }
      return;
    }
    var shopSize = e.target.closest('[data-shop-size]');
    if (shopSize) {
      var sv = shopSize.getAttribute('data-shop-size');
      shopState.size = (shopState.size === sv) ? null : sv;
      buildFilterPills(); applyFilters(); return;
    }
    var shopColor = e.target.closest('[data-shop-color]');
    if (shopColor) {
      var cv = shopColor.getAttribute('data-shop-color');
      shopState.color = (shopState.color === cv) ? null : cv;
      buildFilterPills(); applyFilters(); return;
    }
    var stockBtn = e.target.closest('[data-shop-stock]');
    if (stockBtn) {
      shopState.inStockOnly = !shopState.inStockOnly;
      stockBtn.classList.toggle('btn-primary', shopState.inStockOnly);
      stockBtn.classList.toggle('btn-ghost', !shopState.inStockOnly);
      stockBtn.setAttribute('aria-pressed', shopState.inStockOnly);
      applyFilters(); return;
    }
    var clearBtn = e.target.closest('[data-clear-filters]');
    if (clearBtn) { clearFilters(); return; }

    if (e.target.closest('[data-open-cart]')) { openDrawer(); return; }
    if (e.target.closest('[data-close-cart]')) { closeDrawer(); return; }

    // PDP full-description toggle
    var descToggle = e.target.closest('[data-desc-toggle]');
    if (descToggle) {
      var short = document.querySelector('[data-desc-short]');
      var full = document.querySelector('[data-desc-full]');
      if (short && full) {
        var expanded = !full.hidden;
        full.hidden = expanded;
        short.hidden = !expanded;
        descToggle.textContent = expanded ? 'View full description' : 'Show less';
      }
      return;
    }

    // Subscription PDP realm pills
    var realmPill = e.target.closest('[data-realm-value]');
    if (realmPill) {
      var rrow = realmPill.parentElement;
      if (rrow) {
        rrow.querySelectorAll('[data-realm-value]').forEach(function (b) { b.classList.remove('btn-primary'); b.classList.add('btn-ghost'); });
      }
      realmPill.classList.remove('btn-ghost');
      realmPill.classList.add('btn-primary');
      activeRealm = realmPill.getAttribute('data-realm-value');
      // swap the product photo to this realm's representative tee
      var rImg = realmPill.getAttribute('data-img');
      var mainImg = document.getElementById('pdp-main-img');
      if (rImg && mainImg) {
        mainImg.setAttribute('data-front', rImg);
        mainImg.setAttribute('data-back', '');
        swapMain(rImg, false);
        updateThumbs('', false, rImg);
      }
      // shift the media glow to this realm's color
      var rColor = realmPill.getAttribute('data-realm-color');
      var pdpMedia = document.querySelector('.pdp-media');
      if (rColor && pdpMedia) pdpMedia.style.setProperty('--glow', rColor);
      syncRealmLine(realmPill);
      syncVariant();
      return;
    }

    // Subscription modal realm selection
    var subRealm = e.target.closest('[data-subrealm]');
    if (subRealm) {
      var wrap = subRealm.parentElement;
      if (wrap) {
        wrap.querySelectorAll('[data-subrealm]').forEach(function (b) { b.classList.remove('btn-primary'); b.classList.add('btn-ghost'); });
      }
      subRealm.classList.remove('btn-ghost');
      subRealm.classList.add('btn-primary');
      updateSubCta();
      return;
    }

    // Subscription modal size selection
    var subSize = e.target.closest('[data-subsize]');
    if (subSize) {
      var sw = subSize.parentElement;
      if (sw) {
        sw.querySelectorAll('[data-subsize]').forEach(function (b) { b.classList.remove('active'); });
      }
      subSize.classList.add('active');
      updateSubCta();
      return;
    }

    if (e.target.closest('[data-open-sub]')) { e.preventDefault(); openSub(); return; }
    if (e.target.closest('[data-close-sub]')) { closeAllModals(); return; }
  });

  /* Close the filter dropdown when clicking outside it. */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-toggle]') || e.target.closest('[data-filter-dropdown]')) return;
    var dd = document.querySelector('[data-filter-dropdown]');
    var ft = document.querySelector('[data-filter-toggle]');
    if (dd && dd.classList.contains('open')) {
      dd.classList.remove('open');
      if (ft) ft.setAttribute('aria-expanded', 'false');
    }
  });

  /* ---------- Subscription modal ---------- */
  function openSub() {
    var body = document.getElementById('sub-body');
    if (!body) return;
    var subUrl = body.getAttribute('data-sub-url') || '/products/dimension-drop-subscription';
    var subPrice = body.getAttribute('data-sub-price') || '26.99';
    body.innerHTML =
      '<p style="color:var(--text-muted)">One premium tee (retail value up to $32) every month, shipped free. Choose your Realm to start.</p>' +
      '<div class="sub-price" style="margin-top:var(--space-5)"><span class="amt">$' + subPrice + '</span><span class="per">/month</span></div>' +
      '<div class="opt-label" style="margin-top:var(--space-6)">Pick your Realm</div>' +
      '<div class="pill-row">' +
        ['Humor','Sports','Animals','Motivational','Seasonal'].map(function (n, i) {
          return '<button class="btn ' + (i === 0 ? 'btn-primary' : 'btn-ghost') + '" data-subrealm style="min-height:40px">' + n + '</button>';
        }).join('') +
      '</div>' +
      '<div class="opt-label" style="margin-top:var(--space-6)">Size</div>' +
      '<div class="size-row">' + ['S','M','L','XL','2XL','3XL','4XL'].map(function (s, i) {
        return '<button class="size-chip' + (i === 2 ? ' active' : '') + '" data-subsize>' + s + '</button>';
      }).join('') + '</div>' +
      '<a id="sub-cta" class="btn btn-primary block" style="margin-top:var(--space-8)" href="' + subUrl + '">Start the Drop · $' + subPrice + '/mo</a>' +
      '<p class="fine" style="color:var(--text-faint);font-size:var(--text-xs);text-align:center;margin-top:var(--space-4)">Skip or pause anytime. Members keep 20% off the catalog.</p>';
    document.getElementById('sub-modal').classList.add('show');
  }

  /* Carry the chosen Realm + Size into the subscription product URL so the
     customer lands with the right drop preselected. */
  function updateSubCta() {
    var cta = document.getElementById('sub-cta');
    if (!cta) return;
    var base = (document.getElementById('sub-body') || {}).getAttribute
      ? document.getElementById('sub-body').getAttribute('data-sub-url') || '/products/dimension-drop-subscription'
      : '/products/dimension-drop-subscription';
    var realmBtn = document.querySelector('[data-subrealm].btn-primary');
    var sizeBtn = document.querySelector('[data-subsize].active');
    var params = [];
    if (realmBtn) params.push('realm=' + encodeURIComponent(realmBtn.textContent.trim()));
    if (sizeBtn) params.push('size=' + encodeURIComponent(sizeBtn.textContent.trim()));
    cta.setAttribute('href', base + (params.length ? '?' + params.join('&') : ''));
  }

  /* ---------- Variant select → update price + add-to-bag ---------- */
  function fmtMoney(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }
  function updatePricingFromOption(opt) {
    var price = opt.getAttribute('data-price');
    var cents = parseInt(opt.getAttribute('data-cents') || '0', 10);
    var vid = opt.value;
    var addBtn = document.querySelector('.pdp-info [data-add]');
    if (addBtn) {
      addBtn.setAttribute('data-add', vid);
      if (price) addBtn.innerHTML = 'Add to bag · ' + price;
    }
    if (price) {
      var amt = document.querySelector('[data-price-amt]');
      if (amt) amt.textContent = price;
    }
    if (cents) {
      var member = document.querySelector('[data-member-price]');
      if (member) member.textContent = fmtMoney(Math.round(cents * 0.8));
      var sub = document.querySelector('[data-sub-price]');
      if (sub) sub.textContent = fmtMoney(Math.round(cents * 0.8));
    }
  }
  document.addEventListener('change', function (e) {
    var vSel = e.target.closest('[data-variant-select]');
    if (vSel) {
      var opt = vSel.options[vSel.selectedIndex];
      updatePricingFromOption(opt);
    }
  });

  /* ---------- Capture form ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-capture]');
    if (f) { e.preventDefault(); f.reset(); toast('You are in — 20% code on the way', true); }
  });

  /* ---------- Try-on (FITS) → keep our cart drawer in sync ---------- */
  // The FITS try-on modal posts straight to /cart/add.js and then fires a
  // 'cart:updated' CustomEvent; keep our badge + drawer in lockstep with it.
  document.addEventListener('cart:updated', function (e) {
    var cart = e && e.detail;
    if (cart && cart.items) { cartCache = cart; updateCartUI(cart); return; }
    fetchCart().then(function (c) { cartCache = c; updateCartUI(c); }).catch(function () {});
  });

  /* ---------- Try-on auto-open (?tryon=1) ---------- */
  var tryonOpenAttempts = 0;
  function tryAutoOpenWidget() {
    if (window.location.search.indexOf('tryon=1') === -1) return;
    var btn = document.querySelector('.try-on-button-block button');
    if (!btn) {
      // FITS mounts its React button shortly after DOMContentLoaded.
      if (++tryonOpenAttempts < 30) setTimeout(tryAutoOpenWidget, 200);
      return;
    }
    btn.click();
    // Strip the flag so a refresh doesn't re-open the popup.
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('tryon');
      window.history.replaceState({}, '', u.toString());
    } catch (err) {}
  }

  /* ---------- Boot ---------- */
  function boot() {
    setTheme('dark');
    initEmbers();
    initCursorGlow();
    setupReveals();
    setupLazyVideos();
    forceBackgroundAutoplay();
    buildFilterPills();
    applyFilters();

    var as = document.querySelector('.pdp-info .size-chip.active');
    if (as) activeSize = as.getAttribute('data-size');
    var ac = document.querySelector('.pdp-color-switch .swatch.active');
    if (ac) activeColor = ac.getAttribute('data-color');
    var ar = document.querySelector('.realm-row [data-realm-value].btn-primary');
    if (ar) activeRealm = ar.getAttribute('data-realm-value');

    // Pre-select the variant when landing from the Drop modal (?realm=..&size=..).
    try {
      var qs = new URLSearchParams(window.location.search);
      var qRealm = qs.get('realm'), qSize = qs.get('size');
      var optSel = document.querySelector('[data-variant-select]');
      if (optSel && (qRealm || qSize)) {
        var opts = optSel.querySelectorAll('option');
        for (var qi = 0; qi < opts.length; qi++) {
          var ov = [];
          try { ov = JSON.parse(opts[qi].getAttribute('data-options') || '[]'); } catch (err) { ov = []; }
          var realmOk = !qRealm || ov.indexOf(qRealm) >= 0;
          var sizeOk = !qSize || ov.indexOf(qSize) >= 0;
          if (realmOk && sizeOk) {
            optSel.value = opts[qi].value;
            optSel.dispatchEvent(new Event('change', { bubbles: true }));
            if (qSize) activeSize = qSize;
            if (qRealm) activeRealm = qRealm;
            var chip = document.querySelector('[data-size="' + qSize + '"]');
            if (chip) {
              document.querySelectorAll('.pdp-info .size-chip').forEach(function (s) { s.classList.remove('active'); });
              chip.classList.add('active');
            }
            var rp = document.querySelector('[data-realm-value="' + qRealm + '"]');
            if (rp) {
              document.querySelectorAll('.realm-row [data-realm-value]').forEach(function (b) { b.classList.remove('btn-primary'); b.classList.add('btn-ghost'); });
              rp.classList.remove('btn-ghost'); rp.classList.add('btn-primary');
              var qiImg = rp.getAttribute('data-img');
              var qiMain = document.getElementById('pdp-main-img');
              if (qiImg && qiMain) {
                qiMain.setAttribute('data-front', qiImg);
                qiMain.setAttribute('data-back', '');
                swapMain(qiImg, false);
                updateThumbs('', false, qiImg);
              }
              var qiColor = rp.getAttribute('data-realm-color');
              var qiMedia = document.querySelector('.pdp-media');
              if (qiColor && qiMedia) qiMedia.style.setProperty('--glow', qiColor);
              syncRealmLine(rp);
            }
            break;
          }
        }
      }
    } catch (err) {}

    var tt = document.getElementById('theme-toggle');
    if (tt) tt.addEventListener('click', function () { setTheme(theme === 'dark' ? 'light' : 'dark'); });
    var mb = document.getElementById('menu-btn');
    if (mb) mb.addEventListener('click', function () { var n = document.getElementById('site-nav'); if (n) n.classList.toggle('open'); });
    var nav = document.getElementById('site-nav');
    if (nav) nav.addEventListener('click', function () { nav.classList.remove('open'); });

    // Prime the cart drawer with the current Shopify cart.
    fetchCart().then(function (cart) { cartCache = cart; updateCartUI(cart); }).catch(function () {});

    // Open the try-on modal automatically when arriving from a "Try it on" chip.
    tryAutoOpenWidget();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ============ Tee Dimension — prevent stuck scroll-lock ============ */
/* The FITS try-on app locks body/html overflow while its dialog is open and,
   on some iPhones, doesn't restore it — leaving the page un-scrollable. Clear
   any leftover lock whenever no third-party modal is actually open. */
(function () {
  'use strict';
  function anyOpenModal() {
    var d = document.querySelector('dialog[open], [class*="_tryOnModal"][open]');
    if (d) {
      var r = d.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return true;
    }
    return false;
  }
  function unlock() {
    if (anyOpenModal()) return;
    var b = document.body, h = document.documentElement;
    if (b.style.overflow === 'hidden') b.style.overflow = '';
    if (h.style.overflow === 'hidden') h.style.overflow = '';
    if (b.classList.contains('overflow-hidden')) b.classList.remove('overflow-hidden');
  }
  window.addEventListener('scroll', unlock, { passive: true });
  window.addEventListener('touchstart', unlock, { passive: true });
  setInterval(unlock, 1200);
})();

/* ============ Tee Dimension — scroll-reveal failsafe ============ */
/* Some mobile browsers don't fire IntersectionObserver reliably, leaving
   .reveal elements stuck at opacity:0. This scroll/resize fallback reveals
   anything already in the viewport, matching what the observer should do. */
(function () {
  'use strict';
  function revealVisible() {
    var els = document.querySelectorAll('.reveal:not(.revealed)');
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) {
        els[i].classList.add('revealed');
      }
    }
  }
  var ticking = false;
  function kick() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { revealVisible(); ticking = false; });
  }
  window.addEventListener('scroll', kick, { passive: true });
  window.addEventListener('resize', kick, { passive: true });
  window.addEventListener('orientationchange', kick);
  setTimeout(revealVisible, 350);
  setTimeout(revealVisible, 1200);
})();
